import { InteractiveContainer } from '@acies/core';
import Icon from './icon';
import theme from './theme';
import XCloseButtonEvent from './x-close-button-event';

export default class XCloseButton extends InteractiveContainer {
	#icon!: Icon;

	private get icon(): Icon {
		if (!this.#icon) {
			this.#icon = new Icon();
			this.#icon.width = 12;
			this.#icon.height = 12;
			this.#icon.strokeWeight = 1;
			this.#icon.name = 'x-close';
		}
		return this.#icon;
	}

	public constructor() {
		super();
		this.width = 16;
		this.height = 16;
		this.cornerRadius = 4;
		this.cursor = 'pointer';
		this.alignment = 'center';
	}

	protected override clicked(event: Event): void {
		super.clicked(event);
		this.dispatchEvent(new XCloseButtonEvent());
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponent(this.icon);
	}

	protected override stateChanged(): void {
		super.stateChanged();
		this.#updateStyles();
	}

	/** Only the focus is marked. Hovering is not styled: the cursor is what says the button can be pressed. */
	#updateStyles(): void {
		if (this.styledState === 'focused') {
			this.stroke = theme.strokes.focus;
			this.fill = theme.colors.fill.focus;
		} else {
			this.stroke = null;
			this.fill = null;
		}
	}
}
customElements.define('ac-x-close-button', XCloseButton);
